import { ExperimentTypeSubheaderWrapper } from './Styled';

type ExperimentTypeSubHeaderProps = {
  text: string;
};
export const ExperimentTypeSubHeader = ({ text }: ExperimentTypeSubHeaderProps) => {
  return (
    <ExperimentTypeSubheaderWrapper data-test="experiment-type-sub-header">
      {text}
    </ExperimentTypeSubheaderWrapper>
  );
};
